/**
 * Service Worker registration helper for PrepMasters PWA.
 * Only registers in production builds and on https/localhost.
 */
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only register in production builds; CRA dev server doesn't serve a real SW well.
  if (process.env.NODE_ENV !== "production") return;

  const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
  if (!isSecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("[PWA] Service worker registration failed:", err);
    });
  });
}
